module.exports = __webpack_public_path__ + "img/ic_logout_primary.13dd188d.svg";